<template>
    <span class="floating-label">
        <span v-if="isFontAwesome">
            <i :class="['icon', icon]"></i>
        </span>

        <span class="square" v-else-if="icon">
            {{ icon }}
        </span>

        <span class="label">{{ label }}</span>
    </span>
</template>

<script>
export default {
    props: {
        label: String,
        icon: String,
    },
    computed: {
        isFontAwesome: function () {
            if (this.icon) {
                return this.icon.indexOf('fa-') >= 0
            }

            return false
        },
    },
}
</script>
